/**
 * PDP recommendation carousels: sync title/price block heights per visible row on mobile.
 * Mirrors plp-mobile-card.js for .pdp-rec-mobile-plp swiper slides.
 */
(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 749px)');
  var MAX_LINES = 4;
  var CAROUSEL_SELECTOR = '.pdp-rec-mobile-plp';
  var HEADING_SELECTOR = '.card--standard > .card__content .card__heading';
  var PRICE_SELECTOR = '.card--standard > .card__content .card-information > .price';

  function getTitleNode(heading) {
    if (!heading) return null;
    return (
      heading.querySelector('.full-unstyled-link') ||
      heading.querySelector('.card__title-text')
    );
  }

  function measureTitleHeight(heading) {
    var titleNode = getTitleNode(heading);
    if (!titleNode) return 0;

    heading.style.minHeight = '';
    var lineHeight = parseFloat(getComputedStyle(titleNode).lineHeight) || 21;
    var maxHeight = lineHeight * MAX_LINES;
    return Math.min(titleNode.scrollHeight, maxHeight);
  }

  function setTitleBlockHeight(heading, heightPx) {
    heading.style.minHeight = heightPx + 'px';
  }

  function clearTitleBlockHeight(heading) {
    heading.style.minHeight = '';
  }

  function clearPriceBlockHeight(price) {
    price.style.minHeight = '';
  }

  function measurePriceHeight(price) {
    clearPriceBlockHeight(price);
    return price.offsetHeight;
  }

  function setPriceBlockHeight(price, heightPx) {
    price.style.minHeight = heightPx + 'px';
  }

  function syncRowPair(items) {
    var headings = items
      .map(function (item) {
        return item.querySelector(HEADING_SELECTOR);
      })
      .filter(Boolean);

    var prices = items
      .map(function (item) {
        return item.querySelector(PRICE_SELECTOR);
      })
      .filter(Boolean);

    if (!headings.length && !prices.length) return;

    var maxTitleHeight = 0;
    headings.forEach(function (heading) {
      var h = measureTitleHeight(heading);
      if (h > maxTitleHeight) maxTitleHeight = h;
    });

    headings.forEach(function (heading) {
      setTitleBlockHeight(heading, maxTitleHeight);
    });

    var maxPriceHeight = 0;
    prices.forEach(function (price) {
      var h = measurePriceHeight(price);
      if (h > maxPriceHeight) maxPriceHeight = h;
    });

    prices.forEach(function (price) {
      setPriceBlockHeight(price, maxPriceHeight);
    });
  }

  function syncPdpRecCardTitles() {
    if (!MOBILE_MQ.matches) {
      document.querySelectorAll(CAROUSEL_SELECTOR + ' ' + HEADING_SELECTOR).forEach(clearTitleBlockHeight);
      document.querySelectorAll(CAROUSEL_SELECTOR + ' ' + PRICE_SELECTOR).forEach(clearPriceBlockHeight);
      return;
    }

    document.querySelectorAll(CAROUSEL_SELECTOR).forEach(function (carousel) {
      var items = Array.prototype.slice
        .call(carousel.querySelectorAll('.swiper-slide'))
        .filter(function (item) {
          return item.style.display !== 'none' && item.querySelector('.card-wrapper');
        });

      for (var i = 0; i < items.length; i += 2) {
        syncRowPair(items.slice(i, i + 2));
      }
    });
  }

  var debounceTimer;
  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncPdpRecCardTitles, 80);
  }

  document.addEventListener('DOMContentLoaded', scheduleSync);
  MOBILE_MQ.addEventListener('change', scheduleSync);
  window.addEventListener('resize', scheduleSync);
  window.addEventListener('load', scheduleSync);

  document.addEventListener('DOMContentLoaded', function () {
    function observeCarousel(carousel) {
      if (!carousel || carousel.dataset.pdpRecObserved) return;
      carousel.dataset.pdpRecObserved = 'true';
      new MutationObserver(scheduleSync).observe(carousel, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });
    }

    document.querySelectorAll(CAROUSEL_SELECTOR).forEach(observeCarousel);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(CAROUSEL_SELECTOR)) {
            observeCarousel(node);
            scheduleSync();
          }
          if (node.querySelectorAll) {
            node.querySelectorAll(CAROUSEL_SELECTOR).forEach(function (carousel) {
              observeCarousel(carousel);
            });
            if (node.querySelector(CAROUSEL_SELECTOR)) scheduleSync();
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });

  window.syncPdpRecCardTitles = syncPdpRecCardTitles;
})();
